import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import { history } from "../../helpers/history";
import clientmanagmentObj from "../../services/client-managment.service";
import depositService from "../../services/deposit.service";
import useBopayCanvas from "../../helpers/useBopayCanvas";
import BoAgent from "../superadmin/BoAgent";
const Navigation = (props) => {
  const [activeClass, setActiveClass] = useState();
  const [depositcount, setDepositcount] = useState(0);
  const [changepincount, setChangepincount] = useState(0);
  const applyActiveClass = (id) => {
    setActiveClass(id);
  };

  // Paints the warm pink canvas while the admin shell is mounted.
  // Reference-counted so a screen that also claims it cannot strip it early.
  useBopayCanvas();

  // Collapsed rail state. Kept on <body> rather than on the rail itself
  // because the content column has to widen in response, and persisted so the
  // choice survives navigation and reloads.
  const [navCollapsed, setNavCollapsed] = useState(() => {
    try {
      return localStorage.getItem("bopayNavCollapsed") === "true";
    } catch (e) {
      return false;
    }
  });

  useEffect(() => {
    document.body.classList.toggle("bopay-nav-collapsed", navCollapsed);
    try {
      localStorage.setItem("bopayNavCollapsed", navCollapsed ? "true" : "false");
    } catch (e) {
      /* private mode / blocked storage — the class still applies for this session */
    }
    return () => document.body.classList.remove("bopay-nav-collapsed");
  }, [navCollapsed]);

  // Dark mode. Set on <html> rather than <body> so the attribute is present
  // before paint and the token overrides apply to everything, including the
  // fixed translate widget which sits outside the app root.
  // Bo Agent panel. Read-only assistant — see helpers/boAgentTools.js.
  const [agentOpen, setAgentOpen] = useState(false);

  const [darkMode, setDarkMode] = useState(() => {
    try {
      return localStorage.getItem("bopayTheme") === "dark";
    } catch (e) {
      return false;
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (darkMode) root.setAttribute("data-bopay-theme", "dark");
    else root.removeAttribute("data-bopay-theme");
    try {
      localStorage.setItem("bopayTheme", darkMode ? "dark" : "light");
    } catch (e) {
      /* blocked storage — the attribute still applies for this session */
    }
    return () => root.removeAttribute("data-bopay-theme");
  }, [darkMode]);

  const getCountAPIs = () => {
    depositService.getDepositCounts(
      "", "Pending", "0001-01-01", "0001-01-01", "0001-01-01", "0001-01-01", "", 1, ""
    ).then((resp) => {
      setDepositcount(resp?.data?.payload?.result?.totalCount);
    }).catch();
    clientmanagmentObj.getChangePinCount("", "", "0001-01-01T00:00:00.000Z", "0001-01-01T00:00:00.000Z", "", 1).then((resp) => {
      setChangepincount(resp?.data?.payload?.result?.totalCount)
    }).catch((error) => {

    });
  }

  useEffect(() => {
    setTimeout(() => {
      setActiveClass(window.location.pathname.replace("/", ""));
    }, 200);
    getCountAPIs();
  }, []);
  const closeLeftMenu = () => {
    if (document.getElementById("boMenu").classList.contains("bo-menu-overlay")) {
      document.getElementById("boMenu").classList.remove("bo-menu-overlay");
      document.getElementById("body").style = "overflow: visible";
      document.getElementById("leftNav").style.cssText =
        "position: unset; width: 0; height: 0; z-index: ; display : none";
    }
  }

  // One nav row. Keeps the classic <i> element so the icomoon glyphs still
  // render, and maps active state onto the new accent-bar class. `badge` is
  // rendered only when a count is supplied.
  // The label is wrapped so the collapsed rail can hide it, and `title` gives
  // the browser's own tooltip when collapsed (a CSS tooltip would be clipped
  // by the rail's internal scroll container).
  const navItem = (id, to, icon, label, key, badge, extraOnClick) => (
    <li key={key || id}>
      <Link
        id={id}
        to={to}
        title={label}
        className={
          "bopay-nav-item" +
          (activeClass === key ? " bopay-nav-item--active" : "")
        }
        onClick={() => {
          applyActiveClass(key);
          closeLeftMenu();
          if (extraOnClick) extraOnClick();
        }}
      >
        <i className={icon}></i>
        <span className="bopay-nav-label">{label}</span>
        {badge !== undefined && badge !== null && (
          <span className="bopay-nav-badge">{badge}</span>
        )}
      </Link>
    </li>
  );

  const logoutBlock = (
    <Link
      to={"/login"}
      className="bopay-nav-logout"
      title={"Logout" + (props.username ? " — " + props.username : "")}
      onClick={() => { props.logOut(); closeLeftMenu(); }}
    >
      <i className="icon-logout"></i>
      <span className="bopay-nav-label">
        Logout
        <span className="bopay-nav-username">{props.username}</span>
      </span>
    </Link>
  );

  return (
    <div className="col-lg-3 col-md-0 bo-sidebar-col bopay-nav" id="leftNav">
      <div className="bo-sidebar-outer">
        <div className="bopay-nav-head">
          <Link
            to="/dashboard"
            onClick={() => { applyActiveClass("dashboard"); closeLeftMenu(); }}
          >
            <div className="bopay-nav-wordmark">
              <span className="bopay-nav-wordmark-bo">Bo</span>
              <span className="bopay-nav-wordmark-payments">Payments</span>
            </div>
            <span className="bopay-nav-env">Super Admin</span>
          </Link>
        </div>
        {

        }
        <ul className="bopay-nav-list">
          {props.role !== null && (
            <Fragment>
              {(props.role.includes("Super admin")) ? (
                <Fragment>
                  <li>
                    <button
                      type="button"
                      className="bopay-nav-agent"
                      onClick={() => setAgentOpen(true)}
                      title="Bo AI Agent (beta)"
                    >
                      <span className="bopay-nav-agent-mark" aria-hidden="true">bo</span>
                      <span className="bopay-nav-agent-text">Bo AI Agent</span>
                      <span className="bopay-nav-agent-beta">beta</span>
                    </button>
                  </li>

                  {navItem("homeNavLink", "/home", "icon-dashboard", "Home", "home")}
                  {navItem("dashboardNavLink", "/dashboard", "icon-dashboard", "Dashboard", "dashboard", undefined, getCountAPIs)}
                  {navItem("cardsNavLink", "/cards", "icon-card", "Cards", "cards")}
                  {navItem("clientNavLink", "/clients", "icon-client", "Clients", "clients")}
                  {navItem("clientNavLink", "/superclients", "icon-client", "Super Clients", "superclients")}
                  {
                    props?.depositpermission && (
                      navItem("depositNavLink", "/deposit", "icon-deposit", "Deposit", "deposit", depositcount)
                    )
                  }
                  {navItem("moneyNavLink", "/sendmoney", "icon-transaction", "Send Money", "money")}
                  {
                    props?.rolemanagmentpermission && (
                      navItem("rolesNavLink", "/rolemanagment", "icon-RoleManagement", "Role Management", "rolemanagment")
                    )
                  }
                  {navItem("KeyNavLink", "/changepins", "icon-ChangePIN", "Change Pin", "changepins", changepincount)}
                  {navItem("KeyNavLink", "/declinetransactions", "icon-Wallet", "Decline Transaction", "declinetransactions")}
                  {
                    props?.FeeManagement &&(
                      <>
                      {navItem("FeeNavLink", "/feemanagments", "icon-Wallet", "Fee Management", "feemanagments")}
                      {navItem("NegativeTransactionsNavLink", "/negativetransactions", "icon-transaction", "Negative Balance(s)", "negativetransactions")}
                      {navItem("apikeymanagmentNavLink", "/apikeymanagment", "icon-settings", "API Key Managment", "apikeymanagment")}
                      {navItem("logrecordsNavLink", "/logrecords", "icon-settings", "Log Records", "logrecords")}
                      </>


                    )
                  }

                  {navItem("settingsNavLink", "/settings", "icon-settings", "Settings", "settings")}

                  <li className="bopay-nav-foot">
                    <hr className="bopay-nav-sep" />
                    <button
                      type="button"
                      className="bopay-nav-toggle"
                      onClick={() => setNavCollapsed(!navCollapsed)}
                      title={navCollapsed ? "Expand menu" : "Collapse menu"}
                      aria-label={navCollapsed ? "Expand menu" : "Collapse menu"}
                      aria-expanded={!navCollapsed}
                    >
                      <span className="bopay-nav-toggle-chevron"></span>
                      <span className="bopay-nav-toggle-text">Collapse</span>
                    </button>
                    <button
                      type="button"
                      className="bopay-theme-toggle"
                      onClick={() => setDarkMode(!darkMode)}
                      title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
                      aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
                      aria-pressed={darkMode}
                    >
                      <span className="bopay-theme-toggle-mark"></span>
                      <span className="bopay-theme-toggle-text">
                        {darkMode ? "Light" : "Dark"}
                      </span>
                    </button>
                    {logoutBlock}
                  </li>

                </Fragment>
              ) : (
                <div>

                  {history.push("/login")}

                  {logoutBlock}
                </div>
              )}
            </Fragment>
          )}


        </ul>
      </div>

      {/* Bo Agent slides over the content; rendered here so it is available
          from every screen the nav is mounted on. */}
      <BoAgent open={agentOpen} onClose={() => setAgentOpen(false)} />
    </div>
  );
};
export default Navigation;
